import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    OFFER_LIST_START: "OFFER_LIST_START",
    OFFER_LIST_SUCCESS: "OFFER_LIST_SUCCESS",
    OFFER_LIST_FAILED: "OFFER_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const offerListStart = (data) => ({
    type: actionType.OFFER_LIST_START,
    payload: data,
});

export const offerListSuccess = (data) => ({
    type: actionType.OFFER_LIST_SUCCESS,
    payload: data,
});

export const offerListFailed = (data) => ({
    type: actionType.OFFER_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function offerListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.OFFER_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.OFFER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.OFFER_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* offerListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const alloffer =  response.data.data.allOffersdropdwns.Offersdropdwns
            yield put(offerListSuccess(alloffer));
        } else {
            messagePopup("", "Offer List failed", "error");
            yield put(offerListFailed("Offer List failed"));
        }
    } catch (error) {
        messagePopup("", "Offer List failed", "error");
        yield put(offerListFailed("Offer List failed"));
    }
}

export function* watchOfferListSaga() {
    yield takeEvery(actionType.OFFER_LIST_START, offerListSaga);
}
